(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BillingFrequencyDialogController', BillingFrequencyDialogController);

    BillingFrequencyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BillingFrequency'];

    function BillingFrequencyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BillingFrequency) {
        var vm = this;

        vm.billingFrequency = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.billingFrequency.id !== null) {
                BillingFrequency.update(vm.billingFrequency, onSaveSuccess, onSaveError);
            } else {
                BillingFrequency.save(vm.billingFrequency, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:billingFrequencyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
